import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Services
import { getProductOrder } from "../../../services/productServices";

// Components
import ProductOrders from "./ProductOrders";
import PageWrapper from "../../../components/PageWrapper";
import Loader from "../../../components/Loader";
import BackToDashboard from "../../../components/BackToDashboard";
import useLanguage from "../../../utils/useLanguage";
import nextIcon from "../../../assets/next_icon.png";
import previousIcon from "../../../assets/previous_icon.png";
import UniformOrders from "./UniformOrders";

export default function ProductOrdersPage() {
  // HOOKS
  const { orderNumber } = useParams();
  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();
  const navigate = useNavigate();

  // STATES
  const [productOrderItems, setProductOrderItems] = useState([]);
  const [orderStatus, setOrderStatus] = useState("PENDING");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refetch, setRefetch] = useState(false);

  const fetchProductOrder = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getProductOrder(orderNumber);

      setProductOrderItems(response.data);
      setOrderStatus(response.data?.[0]?.status || "PENDING");
    } catch (err) {
      setError(err.message || t("failedToLoadOrder"));
      console.error("Error fetching product order:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProductOrder();
  }, [orderNumber, refetch]);

  if (error) {
    return (
      <PageWrapper withBackButton>
        <div className="u-margin--top_500 u-margin--bottom_500">
          <div className="error-message">
            {error}
            <button onClick={fetchProductOrder} className="retry-button">
              {t("retry")}
            </button>
          </div>
        </div>
      </PageWrapper>
    );
  }
  const isUniform = productOrderItems?.at(0)?.type === "uniform"

  return (
    <PageWrapper withBackButton>
      <div className="u-margin--top_500 u-margin--bottom_500">
        {loading ? (
          <Loader />
        ) : (
          <>
          {
            isUniform ? (
              <UniformOrders
                data={productOrderItems}
                setData={setProductOrderItems}
                orderStatus={orderStatus}
                refetch={fetchProductOrder}
                setRefetch={setRefetch}
              />
            ) : (
              <ProductOrders
                data={productOrderItems}
                setData={setProductOrderItems}
                orderStatus={orderStatus}
                refetch={fetchProductOrder}
                setRefetch={setRefetch}
              />
            )
          }
        </>
        )}
      </div>
    </PageWrapper>
  );
}
